<template>
  <div class="tw-flex tw-justify-center tw-space-x-[34px]">
    <PlainButton
      v-if="$listeners['left-action-click']"
      @click="$emit('left-action-click')"
      >{{ leftActionLabel }}</PlainButton
    >
    <PlainButton
      v-if="$listeners['right-action-click']"
      @click="$emit('right-action-click')"
      >{{ rightActionLabel }}</PlainButton
    >
  </div>
</template>

<script>
import PlainButton from './PlainButton'

export default {
  components: {
    PlainButton,
  },
  props: {
    leftActionLabel: {
      type: String,
      required: false,
      default() {
        return this.$t('onboarding_back_to_previous')
      },
    },
    rightActionLabel: {
      type: String,
      required: false,
      default() {
        return this.$t('onboarding_i_will_do_this_later')
      },
    },
  },
}
</script>

<style scoped></style>
